import { z } from 'zod';

export const QrpcOccupancyStatus = z.enum([
  'Vacant',
  'Borrower Occupied',
  'Tenant Occupied',
  'Unknown',
  'Abandoned',
  'Occupied by Unknown',
]);
export type QrpcOccupancyStatus = z.infer<typeof QrpcOccupancyStatus>;
